import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

export const packagesToAdd = [
  {
    name: 'Complete Home Makeover',
    description: 'Transform your entire home with our comprehensive cleaning, repair, and maintenance package',
    longDescription: 'This all-inclusive package covers deep cleaning of your entire home, essential repairs, and maintenance services. Perfect for homeowners looking to refresh their living space without the hassle of booking multiple services.',
    serviceIds: [], // Will be populated after services are added
    serviceNames: ['Deep Home Cleaning', 'Painting', 'Electrical Wiring & Rewiring', 'Plumbing Tap Repair', 'AC Servicing'],
    price: 5999,
    originalPrice: 8995,
    discount: 33,
    savings: 2996,
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80',
      'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&q=80',
      'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80'
    ],
    features: [
      'Complete home deep cleaning (all rooms)',
      'Professional painting service',
      'Electrical safety check & repairs',
      'Plumbing inspection & fixes',
      'AC servicing for 2 units',
      'Free follow-up visit within 30 days'
    ],
    duration: '2-3 days',
    validity: '30 days',
    popular: true,
    featured: true,
    new: false,
    trending: true,
    customTags: ['Best Value', 'Most Popular'],
    showInPopularSection: true,
    isActive: true
  },
  {
    name: 'Bride-to-Be Beauty Package',
    description: 'Complete pre-wedding beauty treatment package for the perfect bridal glow',
    longDescription: 'Get wedding-ready with our comprehensive beauty package designed specifically for brides. Includes bridal makeup trial, hair spa, facial treatments, and manicure-pedicure to ensure you look absolutely stunning on your special day.',
    serviceIds: [],
    serviceNames: ['Bridal Makeup', 'Hair Spa Treatment', 'Facial Treatment', 'Manicure & Pedicure', 'Party Makeup'],
    price: 4999,
    originalPrice: 6995,
    discount: 29,
    savings: 1996,
    image: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=800&q=80',
      'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&q=80',
      'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80'
    ],
    features: [
      'Bridal makeup with trial session',
      'Pre-wedding hair spa treatment',
      'Luxury facial with natural products',
      'Professional manicure & pedicure',
      'Complimentary party makeup for sangeet',
      'Touch-up kit included'
    ],
    duration: '8-10 hours (spread across sessions)',
    validity: '60 days',
    popular: true,
    featured: true,
    new: true,
    trending: true,
    customTags: ['Bridal Special', 'Premium'],
    showInPopularSection: true,
    isActive: true
  },
  {
    name: 'Tech Repair Combo',
    description: 'Complete tech repair solution for all your electronic devices',
    longDescription: 'Save money with our tech repair combo package covering your most-used devices. Perfect for families and professionals who rely on multiple gadgets daily.',
    serviceIds: [],
    serviceNames: ['Laptop Repair', 'Mobile Phone Repair', 'TV Repair', 'AC Repair', 'Refrigerator Repair'],
    price: 2999,
    originalPrice: 4395,
    discount: 32,
    savings: 1396,
    image: 'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=800&q=80',
      'https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=800&q=80',
      'https://images.unsplash.com/photo-1593784991095-a205069470b6?w=800&q=80'
    ],
    features: [
      'Laptop servicing & repair',
      'Mobile screen/battery replacement',
      'TV repair (all brands)',
      'AC gas refilling & repair',
      'Refrigerator cooling fix',
      '3-month warranty on all repairs'
    ],
    duration: '1-2 days',
    validity: '90 days',
    popular: true,
    featured: false,
    new: false,
    trending: true,
    customTags: ['Tech Saver', 'Family Pack'],
    showInPopularSection: true,
    isActive: true
  },
  {
    name: 'Fresh Start Cleaning Bundle',
    description: 'Perfect cleaning package for move-in, move-out, or seasonal deep cleaning',
    longDescription: 'Get your home sparkling clean with our comprehensive cleaning bundle. Ideal for moving into a new home, preparing for guests, or seasonal cleaning.',
    serviceIds: [],
    serviceNames: ['Full House Cleaning', 'Kitchen Cleaning', 'Bathroom Cleaning', 'Window Cleaning', 'Carpet Cleaning'],
    price: 3499,
    originalPrice: 5395,
    discount: 35,
    savings: 1896,
    image: 'https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?w=800&q=80',
      'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&q=80',
      'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80'
    ],
    features: [
      'Complete house deep cleaning',
      'Kitchen chimney & stove cleaning',
      'Bathroom sanitization',
      'All windows & glass cleaning',
      'Carpet & sofa shampooing',
      'Eco-friendly cleaning products'
    ],
    duration: '1 full day',
    validity: '45 days',
    popular: true,
    featured: false,
    new: true,
    trending: false,
    customTags: ['Move-In Ready', 'Deep Clean'],
    showInPopularSection: true,
    isActive: true
  },
  {
    name: 'Homeowner Essential Care',
    description: 'Monthly maintenance package covering all essential home services',
    longDescription: 'Keep your home in perfect condition with our monthly essential care package. Includes regular maintenance of electrical, plumbing, and appliances to prevent costly repairs.',
    serviceIds: [],
    serviceNames: ['AC Installation', 'Wiring & Rewiring', 'Toilet Installation & Repair', 'Fan Installation & Repair', 'Switch & Socket Repair'],
    price: 3999,
    originalPrice: 5995,
    duration: '1-2 days',
    discount: 33,
    savings: 1996,
    image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80',
      'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800&q=80',
      'https://images.unsplash.com/photo-1585313647787-89baa53c8f35?w=800&q=80'
    ],
    features: [
      'AC installation & testing',
      'Complete electrical safety check',
      'Plumbing inspection & repairs',
      'Fan installation & balancing',
      'Switch & socket upgrades',
      'Priority emergency support'
    ],
    validity: '30 days',
    popular: false,
    featured: true,
    new: false,
    trending: false,
    customTags: ['Maintenance', 'Essential'],
    showInPopularSection: false,
    isActive: true
  }
];

export async function addAllPackages() {
  try {
    console.log('Starting to add packages...');
    
    // First, get all services to map service names to IDs
    const servicesSnapshot = await getDocs(collection(db, 'services'));
    const servicesMap = new Map();
    servicesSnapshot.docs.forEach(doc => {
      const data = doc.data();
      servicesMap.set(data.name, doc.id);
    });
    
    console.log(`Found ${servicesMap.size} services in database`);
    
    // Get existing packages to avoid duplicates
    const packagesSnapshot = await getDocs(collection(db, 'packages'));
    const existingPackages = packagesSnapshot.docs.map(doc => doc.data().name);
    console.log(`Found ${existingPackages.length} existing packages`);
    
    let added = 0;
    let skipped = 0;
    let errors = 0;
    
    for (const pkg of packagesToAdd) {
      if (!existingPackages.includes(pkg.name)) {
        try {
          // Map service names to service IDs
          const serviceIds = pkg.serviceNames
            .map(name => servicesMap.get(name))
            .filter(id => id !== undefined);
          
          if (serviceIds.length === 0) {
            console.warn(`⚠️  Warning: No matching services found for package "${pkg.name}"`);
            errors++;
            continue;
          }
          
          // Remove serviceNames from the package data (it's just for mapping)
          const { serviceNames, ...packageData } = pkg;
          
          await addDoc(collection(db, 'packages'), {
            ...packageData,
            serviceIds,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          });
          
          console.log(`✅ Added: ${pkg.name} (${serviceIds.length} services)`);
          added++;
        } catch (error) {
          console.error(`❌ Error adding package "${pkg.name}":`, error);
          errors++;
        }
      } else {
        console.log(`⏭️  Skipped: ${pkg.name} (already exists)`);
        skipped++;
      }
    }
    
    console.log(`\n✨ Complete! Added ${added} packages, Skipped ${skipped}, Errors ${errors}`);
    return { success: true, added, skipped, errors };
  } catch (error) {
    console.error('Error adding packages:', error);
    return { success: false, error };
  }
}
